import { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { IRequestSMSPurchase, IRequestSMSPurchaseParams, IResponseDataTable } from '../../interfaces/apis';
import packageSmsApis from '../../../../services/packageSmsApis';
import { IGetEmployeesResponse } from '../../../employees/services/types';
import dayjs from 'dayjs';
import { start } from 'repl';

const DEFAULT_PARAMS: IRequestSMSPurchaseParams = {
  page: 1,
  size: 10,
  shopId: undefined,
  startDate: dayjs().subtract(7, 'day').format('MM-DD-YYYY'),
  endDate: dayjs().endOf('day').format('MM-DD-YYYY'),
};

const useGetRequestSMSPurchase = (isLazy = false) => {
  const [params, setParams] = useState<IRequestSMSPurchaseParams>(DEFAULT_PARAMS);

  const [data, setData] = useState<IResponseDataTable<IRequestSMSPurchase>>();
  const [loading, setLoading] = useState(false);

  const fetchData = async (paramsSubmit: IRequestSMSPurchaseParams) => {
    setLoading(true);
    try {
      const response: AxiosResponse<{ data: IResponseDataTable<IRequestSMSPurchase> }> = await packageSmsApis.getRequestSMSPurchase({
        ...paramsSubmit,
        status: paramsSubmit.status ? paramsSubmit.status : undefined,
        shopId: paramsSubmit.shopId ? paramsSubmit.shopId : undefined,
        startDate: dayjs(paramsSubmit.startDate).format('MM-DD-YYYY'),
        endDate: dayjs(paramsSubmit.endDate).format('MM-DD-YYYY'),
      });

      setData(response.data.data);
    } catch (error) {
      setData(undefined);
    } finally {
      setLoading(false);
    }
  };

  const mutate = (newParams?: IRequestSMSPurchaseParams) => {
    setParams((prev) => ({
      ...prev,
      ...newParams,
    }));
  };

  useEffect(() => {
    if (!isLazy) {
      fetchData(params);
    }
  }, [params, isLazy]);

  return {
    data,
    loading,
    params,
    setParams,
    mutate,
  };
};

export default useGetRequestSMSPurchase;
